module.exports = __webpack_public_path__ + "fonts/motiva-sans-black.fe03fb9.otf";